import { Box, BoxProps, styled, Typography } from '@mui/material';
import React from 'react';
import CmsImage from '../../../cms/cmp/CmsImage';
import { IArticle } from '../../../cms/interfaces/IArticle';
import { Option } from '../../form/SHAutocomplete';
import { useTranslation } from 'react-i18next';

interface Props {
    article: IArticle
}

const TeaserBox = styled(Box)<BoxProps>(({theme}) => ({
    "& .teaser-box__category-box": {
        position: 'absolute', 
        height: '0'
    },
    "& .teaser-box__category-box__category": {
        borderTopLeftRadius: '0.5em',
        position: 'relative', 
        top: '0em', 
        textAlign: 'right', 
        backgroundColor: '#21212199', 
        color: '#fff', 
        padding: '0.2em', 
        fontSize: '0.8em'
    },
    "& .teaser-box__headline-box": {
        background: '#fff'
    },
    "& .teaser-box__headline-box__headline": {
        marginTop: '0.5em', 
        color: theme?.palette?.secondary?.main
    },
    "& picture, & img": {
        borderTopLeftRadius: '0.5em',
        borderBottomRightRadius: '0.5em'
    }
}));

const Teaser : React.FC<Props> = ({article}) => {
    const {t} = useTranslation('common');
    const categories = t("common.article.category.list", {returnObjects: true}) as Option[];

    return <TeaserBox>
        <Box className="teaser-box__category-box">
            <Box className="teaser-box__category-box__category">{categories.find(c => c.key === article?.category)?.label}</Box>
        </Box>
        {article?.image && <CmsImage {...article?.image} />}
        <Box className="teaser-box__headline-box">
            <Typography className="teaser-box__headline-box__headline" variant="body1" sx={{}}>{article?.headline}</Typography>
        </Box>
    </TeaserBox>
}

export default Teaser;